export default "__VITE_ASSET__bb8cf657__"